import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "text-dark order-2 order-md-1" }
const _hoisted_4 = {
  href: "https://www.mongolbank.mn",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        container: !_ctx.footerWidthFluid
      }])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.copyRight), 1)
      ])
    ], 2)
  ]))
}